import { useEffect, useRef, useState } from "react";
import html2canvas from "html2canvas";
import {
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
} from "reactstrap";
import jsPDF from "jspdf";
import QRCodeGenerator from "./QRCodeGenerator";
import FormStepsModal from "./FormStepsModal";
import FormStep4QRModal from "./FormStep4QRModal";
import { useSelector, useDispatch } from "react-redux";
import { Button } from "reactstrap";
import * as htmlToImage from "html-to-image";
import { toPng, toJpeg, toBlob, toPixelData, toSvg } from "html-to-image";
import { updateCampaignFields } from "../CampaignActions";
// import gql from "graphql-tag";
import { gql, useMutation, useQuery } from "@apollo/client";
import {
  downloadIcon,
  shareIcon,
  copyIcon,
  copyIconSteps,
  downloadIconbanner,
} from "../../../Shared/SVGs/Shared";
import { removeQueryParams } from "../../../utilities";

const GET_CAMPAIGN = gql`
  mutation MyMutation($campaignId: ID!, $campaign: clipupInput!) {
    updateCampaign(campaignId: $campaignId, campaign: $campaign) {
      _id
      generate_qr
    }
  }
`;

const Step5 = ({ qrcode, setQrcode }) => {
  const activeStep = useSelector((state) => state.campaign_states.activeStep);
  const [qrModal, setQrModal] = useState(false);
  const toggleQrModal = () => setQrModal(!qrModal);
  const toggleQrModals = () => {
    setQrModal(false);
  };
  const [isOpen, setIsOpen] = useState(false);
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(false);
  const [imageData, setImageData] = useState(null);
  const form = useSelector((state) => state.campaign_states.form);
  const banner_with_qr = useSelector(
    (state) => state.campaign_states.form.banner_with_qr
  );
  const banner_share_url = useSelector(
    (state) => state.campaign_states.form.banner_share_url
  );
  const campaign_response = useSelector(
    (state) => state.campaign_states.campaign_response
  );
  const dispatch = useDispatch();

  const [
    updateCampaign,
    { data: CampaignData, loading: createCampaignLoading, error },
  ] = useMutation(GET_CAMPAIGN, {
    onError: (error) => {
      console.log(error);
    },
  });

  useEffect(() => {
    if (campaign_response?._id) {
      updateCampaign({
        variables: {
          campaign: { generate_qr: "Generated" },
          campaignId: campaign_response?._id,
        },
      });
    }
  }, [campaign_response]);

  const componentRef = useRef(null);
  const campaignUrl = `${process.env.REACT_APP_CAMPAGIN_URL}/form/${campaign_response?._id}/landing`;
  const handleCopyClick = () => {
    setCopied(!copied);
    navigator.clipboard.writeText(campaignUrl);
  };
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };

  const GET_PRESIGNED_URL = gql`
    query GetPresignedURL($fileName: String!) {
      getPresignedURL(fileName: $fileName)
    }
  `;

  // console.log(form?.banner_with_qr);
  const UPLOAD_IMAGE_MUTATION = gql`
    mutation MyMutation($imgData: String!, $fileName: String!) {
      imageUpload(imgData: $imgData, fileName: $fileName)
    }
  `;

  const currentDate = new Date();
  const hours = currentDate.getHours().toString().padStart(2, "0");
  const minutes = currentDate.getMinutes().toString().padStart(2, "0");
  const seconds = currentDate.getSeconds().toString().padStart(2, "0");

  const { refetch } = useQuery(GET_PRESIGNED_URL, {
    skip: true,
  });

  const handleImageUpload = async () => {
    try {
      const imgData = form?.banner_with_qr;
      const fileName = `banner-${hours}:${minutes}:${seconds}`;
      // Get presigned URL
      const { data: urlData } = await refetch({
        fileName: fileName + imgData.name,
      });

      // Upload File to preassigned URL
      const uploadImageResponse = await fetch(urlData.getPresignedURL, {
        method: "PUT",
        headers: {
          "Content-Type": imgData?.type,
        },
        body: imgData,
      });

      if (!uploadImageResponse.ok) {
        setLoading(false);
        throw new Error("Failed to upload image");
      }
      dispatch(
        updateCampaignFields({
          banner_share_url: removeQueryParams(urlData.getPresignedURL),
        })
      );
    } catch (error) {
      // console.error("Error uploading image:", error);
    }
  };
  const handleDownload = (format) => {
    const imageElement = document.getElementById(
      qrcode ? "banner" : "image-to-download"
    );

    if (imageElement) {
      html2canvas(imageElement, { useCORS: true })
        .then((canvas) => {
          const dataUrl = canvas.toDataURL(`image/${format}`);
          const link = document.createElement("a");
          link.download = `image.${format}`;
          link.href = dataUrl;
          link.click();
        })
        .catch((error) => {
          console.error("Error generating canvas: ", error);
        });
    }
  };

  const handleDownloadPdf = () => {
    const imageElement = document.getElementById(
      qrcode ? "banner" : "image-to-download"
    );
    if (imageElement) {
      html2canvas(imageElement, { useCORS: true })
        .then((canvas) => {
          const pdf = new jsPDF();
          const imgWidth = 180; // Adjust this width as needed for your PDF
          const imgHeight = (canvas.height * imgWidth) / canvas.width;
          const imgData = canvas.toDataURL("image/jpeg");

          pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
          pdf.save("image.pdf");
        })
        .catch((error) => {
          console.error("Error generating PDF: ", error);
        });
    }
  };

  const canvasRef = useRef(null);

  const toggleChangeContent = () => {
    setQrcode(!qrcode);
    setTimeout(() => {
      html2canvas(canvasRef.current, { useCORS: true, allowTaint: false })
        .then((canvas) => {
          const resizedCanvas = document.createElement("canvas");
          const resizedContext = resizedCanvas.getContext("2d");
          const extraSpace = 100;
          const scaleFactor = Math.min(
            700 / canvas.width,
            (700 - extraSpace) / canvas.height
          );
          const newWidth = canvas.width * scaleFactor;
          const newHeight = (canvas.height - extraSpace) * scaleFactor;
          resizedCanvas.width = newWidth;
          resizedCanvas.height = newHeight;
          resizedContext.drawImage(
            canvas,
            0,
            0,
            canvas.width,
            canvas.height,
            0,
            0,
            newWidth,
            newHeight
          );
          resizedCanvas.toBlob((blob) => {
            if (blob) {
              const file = new File([blob], "image.png", { type: "image/png" });
              dispatch(updateCampaignFields({ banner_with_qr: file }));
            } else {
              console.error("Resized canvas toBlob conversion failed.");
            }
          }, "image/png");
        })
        .catch((error) => {
          console.error("html2canvas error:", error);
        });
    }, 1000);
  };

  useEffect(() => {
    if (banner_with_qr) {
      handleImageUpload();
    }
  }, [banner_with_qr]);

  const style = { width: "158px", color: "#783ad0", textAlign: "center" };

  const dropdown = (
    <DropdownMenu style={{ padding: "0px", width: "158px" }}>
      <DropdownItem onClick={() => handleDownload("png")} style={style}>
        .png
      </DropdownItem>
      <DropdownItem onClick={() => handleDownload("jpeg")} style={style}>
        .jpg
      </DropdownItem>
      <DropdownItem onClick={handleDownloadPdf} style={style}>
        .pdf
      </DropdownItem>
    </DropdownMenu>
  );

  const showCampaignStep = useSelector(
    (state) => state.videoPageStates.campaignsState.showCampaignStep
  );

  const QRCode = (
    <>
      <div className="form-field-label mt-4">QR Code</div>
      <div className="d-flex justify-content-center qr-text qr-heading">
        Participants can scan this QR code and easily upload their video to
        participate in your campaign.
      </div>
      <div className="d-flex justify-content-center">
        <div className="generated-qr mt-2">
          <div className="d-flex justify-content-end align-items-center">
            <div className="mb-1">
              <Dropdown isOpen={isOpen} toggle={toggleDropdown}>
                <DropdownToggle
                  style={{ background: "transparent", border: "none" }}
                >
                  <div className="download-qr main-qr-code d-flex align-items-center">
                    {downloadIcon}
                    <div style={{ marginLeft: "5px" }}>Download</div>
                  </div>
                </DropdownToggle>
                {dropdown}
              </Dropdown>
            </div>
            <div
              className="download-qr mb-1 main-qr-code"
              style={{ marginRight: "17px", marginLeft: "35px" }}
              onClick={handleCopyClick}
            >
              {copyIconSteps} {copied ? "Copied" : "Copy"}
            </div>
          </div>
          <div id="image-to-download" style={{ marginLeft: "30px" }}>
            <QRCodeGenerator
              size={400}
              width={120}
              setLoading={setLoading}
              loading={loading}
              imageData={imageData}
              setImageData={setImageData}
            />
          </div>
        </div>
      </div>
      <div className="d-flex justify-content-center qr-preview mt-5 mb-2">
        Preview Campaign Banner with QR Code
      </div>
      {showCampaignStep && (
        <FormStepsModal
          step={6}
          content={
            "Vyrill saves you design time by crafting the campaign banner for you. Download the JPG file, copy the link, or directly share this banner on your social media platforms."
          }
          style={{ position: "relative", top: "600px", right: "-110px" }}
        />
      )}
    </>
  );
  const corsProxyUrl = "https://api.allorigins.win/raw?url=";

  const banner = (
    <>
      <div className="d-flex justify-content-between mt-4 main-banner-container">
        <div id="banner" className="banner-image" ref={canvasRef}>
          <div
            className="d-flex align-items-center"
            style={{
              border: "1px solid #23BBB8",
              minHeight: "455px",
              width: "763px",
            }}
          >
            <img
              src={
                form?.campaign_banner_image_preview
                  ? form.campaign_banner_image_preview.startsWith("http://") ||
                    form.campaign_banner_image_preview.startsWith("https://")
                    ? `${corsProxyUrl}${encodeURIComponent(
                        form.campaign_banner_image_preview
                      )}`
                    : form.campaign_banner_image_preview
                  : require("@src/assets/images/campaign-default.png").default
              }
              crossOrigin="anonymous"
              style={{
                // height: "455px",
                width: "100%",
                objectFit:
                  campaign_response?.bannerRenderAs === "Fill"
                    ? "cover"
                    : campaign_response?.bannerRenderAs === "Fit"
                    ? "contain"
                    : "contain",
              }}
            />
          </div>
          <div className="d-flex justify-content-between align-items-center">
            <div style={{ width: "518px", marginTop: "-10px" }}>
              <div className="d-flex align-items-center justify-content-center">
                <div
                  className={`preview-headline text-center ${
                    campaign_response?.name?.length < 25 && "large-font"
                  }`}
                >
                  {campaign_response?.name}
                  <div
                    className={`qr-text text-center ${
                      campaign_response?.name?.length < 25 && "large-font-scan"
                    }`}
                  >
                    Scan QR code to know more
                  </div>
                  <div className="mb-2 mt-2">
                    <img
                      style={{
                        objectFit: "contain",
                        maxHeight: "60px",
                        marginBottom: "20px",
                      }}
                      // width={125}
                      src={imageData}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="banner-qr">
              <QRCodeGenerator
                size={195}
                setLoading={setLoading}
                loading={loading}
                // imageData={imageData}
                setImageData={setImageData}
                qrcode={qrcode}
              />
            </div>
          </div>
        </div>
        <div>
          <div className="download-dropdown">
            <Dropdown isOpen={isOpen} toggle={toggleDropdown}>
              <DropdownToggle
                style={{ background: "transparent", border: "none" }}
              >
                <div className="download-qr gap-2 d-flex align-items-center">
                  <div>{downloadIconbanner}</div>
                  <div>Download</div>
                </div>
              </DropdownToggle>
              {dropdown}
            </Dropdown>
          </div>
          <div onClick={toggleQrModal} className="share-banner">
            <div className="download-qr gap-2 d-flex align-items-center">
              <div>{shareIcon}</div>
              <div>Share</div>
            </div>
          </div>
        </div>
        {!showCampaignStep && (
          <FormStepsModal
            step={5}
            content={
              "Vyrill saves you design time by crafting the campaign banner for you. Download the JPG file, copy the link, or directly share this banner on your social media platforms."
            }
            style={{ position: "relative", top: "135px", right: "100px" }}
          />
        )}
      </div>
    </>
  );

  return (
    <div className="form-step-5">
      {qrcode ? banner : QRCode}
      {activeStep === 5 && (
        <FormStep4QRModal
          open={qrModal}
          toggle={toggleQrModals}
          showonlystep4={false}
          // handleEmbedClick={embedCopyImage}
        />
      )}

      {!qrcode && (
        <div className="center mt-5">
          <Button
            className="campaign-button"
            size="lg"
            color={`${loading} ? secondary : primary`}
            disabled={loading}
            style={{ background: loading ? "#C4C4C4" : "" }}
            onClick={toggleChangeContent}
          >
            Preview
          </Button>
        </div>
      )}
    </div>
  );
};

export default Step5;
